// extracted by mini-css-extract-plugin
export var button = "Button-module--button--b1113";
export var filled = "Button-module--filled--cff73";
export var lg = "Button-module--lg--dc2f6";
export var md = "Button-module--md--5ee6d";
export var outlined = "Button-module--outlined--e231c";